import { Popover as BasePopover } from "@base-ui/react/popover";
import type { ReactElement, ReactNode } from "react";
import { cx, usePortalContainer } from "../presentation.tsx";

export interface PopoverProps {
  /** The button that opens it. */
  trigger: ReactElement;
  /** The panel's accessible name (shown as its heading). */
  title: ReactNode;
  /** Beside the heading: e.g. "Mark all read". */
  actions?: ReactNode;
  children?: ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  align?: "start" | "center" | "end";
  className?: string;
}

/** A panel anchored to a button (the notification list): focus moves in, Escape or a click outside closes it. */
export function Popover({ trigger, title, actions, children, open, onOpenChange, align = "end", className }: PopoverProps) {
  const container = usePortalContainer();
  return (
    <BasePopover.Root open={open} onOpenChange={onOpenChange ? (o) => onOpenChange(o) : undefined}>
      <BasePopover.Trigger render={trigger} />
      <BasePopover.Portal container={container}>
        <BasePopover.Positioner className="pmu-popover__positioner" sideOffset={8} align={align}>
          <BasePopover.Popup className={cx("pmu-popup pmu-popover", className)}>
            <div className="pmu-popover__head">
              <BasePopover.Title className="pmu-popover__title">{title}</BasePopover.Title>
              {actions}
            </div>
            <div className="pmu-popover__body">{children}</div>
          </BasePopover.Popup>
        </BasePopover.Positioner>
      </BasePopover.Portal>
    </BasePopover.Root>
  );
}
